import { AttrField, BelongsToField, BooleanField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import type { Nullable } from '@/types'
import { modelNames } from '@/data/models/types'
import type { PriorityEnum } from '@/data/models/domain/types'
import type { KanbanChecklistItemsCount } from '@/data/models/domain/kanban/kanbanChecklistItemsCount'
import { TaskStatus } from '@/services/domain/tasks/types'
import FilterableModel from '@/data/models/FilterableModel'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'

@OrmModel(modelNames.TASK)
export default class Task extends FilterableModel {
  @StringField('')
  public id: string

  @NumberField(null)
  public previousId: Nullable<number>

  @StringField(null, (value) => value && `${value}`)
  public stageId: string

  @StringField(null, (value) => value && `${value}`)
  public boardId: string

  @StringField()
  public title: string

  @StringField()
  public description: string

  @StringField(null, (value) => value && `${value}`)
  public priority: PriorityEnum

  @BooleanField(true)
  public isEditable: boolean

  @StringField()
  public status: TaskStatus

  @AttrField(null)
  public dueDate: Nullable<string>

  @AttrField(null)
  public checklistItemsCount: Nullable<KanbanChecklistItemsCount>

  @AttrField()
  public assigneeId: number | null

  @StringField(null)
  public contactId: Nullable<string>

  @StringField(null)
  public createdById: string | null

  @BelongsToField(UserPersonalInfo, 'createdById')
  public createdBy: UserPersonalInfo | null

  @StringField(null)
  public updatedById: string | null

  @BelongsToField(UserPersonalInfo, 'updatedById')
  public updatedBy: UserPersonalInfo | null

  @StringField()
  public createdAt: string

  @StringField()
  public updatedAt: string

  @StringField(null)
  public createdByAutomationId: string | null

  @AttrField()
  public updatedByAutomationId: string | null

  public get isCompleted(): boolean {
    return this.status === TaskStatus.completed
  }
}
